import React, {useState} from "react";
import {SliderButtonPosition} from "../vehicleSliderButton/VehicleSliderButton";
import styles from "./ImageCarouselSlideButton.module.css";

export const toRgba = (hex: string, alpha: number) => {
    const m = hex.replace("#", "").match(/.{2}/g);
    if (!m) return `rgba(12,1,38,${alpha})`;
    const [r, g, b] = m.map((x) => parseInt(x, 16));
    return `rgba(${r},${g},${b},${alpha})`;
};

interface ImageCarouselSlideButtonProps {
    brandColour: string;
    onClick: () => void;
    position: SliderButtonPosition;
    isDisabled?: boolean;
}

export const ImageCarouselSlideButton: React.FC<ImageCarouselSlideButtonProps> = ({
                                                                                      brandColour,
                                                                                      onClick,
                                                                                      position,
                                                                                      isDisabled,
                                                                                  }) => {
    const bgRest = toRgba(brandColour, 0.65);
    const bgHover = toRgba(brandColour, 0.8);
    const isLeft = position === SliderButtonPosition.BUTTON_LEFT;

    const [hover, setHover] = useState(false);

    return (
        <div
            onClick={onClick}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            className={`${styles.button} ${isLeft ? styles.roundedRight : styles.roundedLeft} ${
                isDisabled ? styles.disabled : styles.enabled
            }`}
            style={{background: hover ? bgHover : bgRest}}
        >
            <svg
                width="24"
                height="24"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={`${styles.icon} ${!isLeft ? styles.rotate : ""}`}
            >
                <path
                    d="M12.5 15.8332L6.66667 9.99984L12.5 4.1665"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </div>
    );
};
